import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentsState } from './payments.state';

export const getPaymentFeatureState = createFeatureSelector('payments');

export const selectCreatePaymentResponse = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.createPaymentResponse
);

export const selectIsLoadingPayments = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.isLoadingPayments
);

export const selectPaymentParams = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.paymentParams
);

export const selectCreditCard = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.creditCard
);

export const selectRequestPaymentResponse = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.requestPaymentResponse
);

export const selectRequestPaymentParams = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.requestPaymentParams
);

export const selectIsDebitCardFlag = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.isDebitCard
);

export const selectPaymentsError = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.error
);

export const selectIsLoadingCardType = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.isLoadingCardType
);

export const selectCreditCardInfo = createSelector(
  getPaymentFeatureState,
  (state: PaymentsState) => state.creditCardInfo
);
